import { createSlice } from '@reduxjs/toolkit';
import { TNavigationState } from 'shared/types/navigation';

const initialState: TNavigationState = {};

/* istanbul ignore next */
const navigationSlice = createSlice({
  initialState,
  name: 'navigation',
  reducers: {},
});

export const { reducer: navReducer } = navigationSlice;
